import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from './store';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter as Router } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import esES from 'antd/es/locale/es_ES';
import 'moment/locale/es';

ReactDOM.render(
    <Provider store={store}>
        <Router>
            <ConfigProvider locale={esES}>
                <App />
            </ConfigProvider>
        </Router>
    </Provider>
, document.getElementById('root'));

serviceWorker.unregister();
